<div tuiCardLarge tuiSurface="elevated">
    <div class="row">
        <div class="col col-12 col-md-8">
            <h2>Télésuivi en cours</h2>
        </div>
        <div class="col col-12 col-md-4 selectionPeriode">
            <tui-input-date-range [maxLength]="maxLength" [(ngModel)]="periode"
                (ngModelChange)="miseAJourMoyenneObservance()">
                Période
            </tui-input-date-range>
        </div>
    </div>
    <div class="row preselectionList">
        <div>
            <p>
                {{ patient?.detailTelesuivi?.periodeList ?
                patient!.detailTelesuivi!.periodeList![patient!.detailTelesuivi!.periodeList!.length - 1].forfait : ''
                }}
            </p>
        </div>
        <div>
            <button [appearance]="periode() == periodeSemaineDerniere ? 'primary' : 'outline'" size="m" tuiButton
                (click)="changePeriode(periodeSemaineDerniere)">
                La semaine dernière
            </button>
            <button [appearance]="periode() == periodeDeuxDernieresSemaines ? 'primary' : 'outline'" size="m" tuiButton
                (click)="changePeriode(periodeDeuxDernieresSemaines)">
                Les deux dernières semaines
            </button>
            <button [appearance]="periode() == periodeMoisDernier ? 'primary' : 'outline'" size="m" tuiButton
                (click)="changePeriode(periodeMoisDernier)">
                Le mois dernier
            </button>
            <button [appearance]="periode() == periodeDeuxDerniersMois ? 'primary' : 'outline'" size="m" tuiButton
                (click)="changePeriode(periodeDeuxDerniersMois)">
                Les deux derniers mois
            </button>
            <button [appearance]="periode() == periodeLAnneeDerniere ? 'primary' : 'outline'" size="m" tuiButton
                (click)="changePeriode(periodeLAnneeDerniere)">
                L'année dernière
            </button>
        </div>

    </div>
    <div class="row">
        <h3>Moyennes sur la période sélectionnée : </h3>
        <p>Observance : {{ moyenneObservance()?.obs != undefined ? (moyenneObservance()!.obs! | obs) : 'Pas de donnée'
            }}</p>
        <p>IAHR : {{ moyenneObservance()?.iahResiduel ? (moyenneObservance()!.iahResiduel! | iahResiduel)
            : 'Pas de donnée' }}</p>
        <p>Fuites : {{ moyenneObservance()?.fuites ? (moyenneObservance()!.fuites! | fuites) : 'Pas de donnée' }}</p>
    </div>
    <div class="row">
        <div class="col col-12">
            <app-telesuivi-graphique-observance-et-iahr [observanceList]="patient?.telesuivi?.observanceList"
                [periode]="periode()" />
        </div>
    </div>
    <div class="row">
        <div class="col col-12">
            <app-telesuivi-graphique-fuites [observanceList]="patient?.telesuivi?.observanceList"
                [periode]="periode()" />
        </div>
    </div>
</div>